import { Navigate, generatePath } from 'react-router-dom';

import { useTypedParams } from '@sorare/routing';

import { BLOG_SPORT_SLUG } from '@sorare/core/src/constants/__generated__/routes';

const Page = () => {
  const { slug } = useTypedParams();

  return (
    <Navigate
      to={generatePath(BLOG_SPORT_SLUG, {
        sport: 'nba',
        slug,
      })}
    />
  );
};
export default Page;
